import jonify from '@utils/jonify';
import formatLocation from '@utils/format-location';

const formatSearchBreadcrumbs = ({ category, location }) => {
  const { parent, label, name, id } = category || {};
  const formattedLocation = jonify(formatLocation(location));

  const getUrl = trade => `/Search/${jonify(trade)}/in/${formattedLocation}`;

  return [
    { label: 'Home', url: '/' },
    parent && {
      label: parent.label,
      schemaLabel: `${parent.label} in ${formattedLocation}`,
      url: getUrl(parent.name),
    },
    id && {
      label,
      schemaLabel: `${label} in ${formattedLocation}`,
      url: getUrl(name),
    },
  ].filter(i => i);
};

export default formatSearchBreadcrumbs;
